var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 295,
    viewBox: "0 0 295 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5580_207)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 147.5,
    cy: 147.5,
    r: 147.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3084 143.106C77.0032 146.097 74.7349 149.983 73.0936 153.725C65.5325 171.059 68.2988 190.936 80.3596 205.978C82.3328 208.431 86.9801 212.836 89.7095 214.878C102.01 224.028 117.778 227.52 132.973 224.476C139.41 223.169 145.717 220.626 151.581 216.937L154.495 215.111L185.753 184.758L217.012 154.406L218.893 151.576C228.095 137.77 230.235 121.761 224.96 106.397C221.235 95.5809 213.766 86.2155 203.623 79.6615C198.644 76.4383 191.083 73.4299 185.034 72.2838C170.17 69.4187 154.587 72.8389 142.637 81.6134C140.571 83.1176 136.588 86.9139 110.567 112.217C86.0396 136.069 80.5993 141.459 79.3084 143.106ZM130.152 123.928L131.222 123.928L151.913 144.02L172.604 164.111L172.604 165.15L172.604 166.188L158.036 180.335C145.772 192.243 143.19 194.679 141.567 195.789C131.019 202.987 116.726 202.97 106.104 195.699C103.762 194.106 100.35 190.793 98.6721 188.483C92.1253 179.404 91.2586 167.317 96.496 157.575C98.6352 153.564 98.7274 153.474 114.458 138.164L129.082 123.928L130.152 123.928ZM156.062 98.0879C161.447 93.5037 167.201 91.4981 174.393 91.6772C181.217 91.8204 186.62 93.8797 191.931 98.3565C194.366 100.434 194.384 100.452 194.808 101.795C195.786 105 194.052 108.116 190.825 108.922C188.667 109.477 187.284 108.993 184.296 106.701C183.301 105.913 181.77 104.928 180.94 104.517C176.68 102.457 170.853 102.565 166.519 104.767C165.191 105.448 164.177 106.289 159.216 110.891L153.462 116.264L152.061 116.514C148.428 117.213 144.831 114.365 144.997 110.945C145.108 108.546 145.385 108.134 149.626 104.015C151.765 101.938 154.661 99.2698 156.062 98.0879Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5580_207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 295,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.62750890dbfa6756c59db8906001d8f4.svg";
export { ForwardRef as ReactComponent };